import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
import { useRef, useState } from "react";
import Story from "@componentsShared/Story/Story";
var RadioCardNew = function RadioCardNew(_ref) {
  var name = _ref.name,
    value = _ref.value,
    checked = _ref.checked,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    title = _ref.title,
    description = _ref.description,
    ctaText = _ref.ctaText,
    priceBox = _ref.priceBox,
    onClickCta = _ref.onClickCta,
    story = _ref.story,
    onClickTitle = _ref.onClickTitle,
    _ref$showStoryModal = _ref.showStoryModal,
    showStoryModal = _ref$showStoryModal === void 0 ? true : _ref$showStoryModal,
    disabledNote = _ref.disabledNote,
    id = _ref.id;
  var storyRef = useRef();
  var _useState = useState(false),
    showStory = _useState[0],
    setShowStory = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: twMerge("p-5 bg-white rounded-lg border border-solid border-gray-echo md:pe-8", disabled && "overflow-hidden cursor-not-allowed pointer-events-none")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "flex items-center gap-4 cursor-pointer"
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge(disabled && "opacity-40")
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: name,
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    className: "opacity-0 hidden"
  }), /*#__PURE__*/React.createElement("div", {
    className: twMerge("w-6 h-6 border border-solid border-[#6B7EA5] rounded-full flex-grow-0 flex-shrink-0", checked ? "border-2 border-black-primary flex items-center justify-center" : "bg-white")
  }, checked && /*#__PURE__*/React.createElement("div", {
    className: "w-3 h-3 bg-primary-new rounded-full"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-1 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2 w-full items-center md:justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 w-full md:gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 flex-wrap w-full"
  }, /*#__PURE__*/React.createElement("h3", {
    className: twMerge("text-start text-black-primary text-base font-bold leading-normal flex w-full", disabled && "opacity-40"),
    onClick: function onClick(e) {
      onClickTitle && onClickTitle(e);
    }
  }, title)), priceBox && /*#__PURE__*/React.createElement("div", {
    className: twMerge(disabled && "opacity-40")
  }, priceBox)), disabled && disabledNote ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1.5 text-[#F22C2C] text-xs font-medium leading-4 p-1 min-h-10 bg-[#F5DDDB] rounded"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/assets/images/danger-error.svg",
    alt: "",
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("span", {
    className: "max-w-[250px] md:max-w-full"
  }, disabledNote)) : /*#__PURE__*/React.createElement("p", {
    className: twMerge("text-start text-[#6B7EA5] text-xs font-semibold leading-7", disabled && "opacity-40")
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick(e) {
      onClickCta && onClickCta(e);
      showStoryModal && setShowStory(true);
    }
  }, description, ctaText && /*#__PURE__*/React.createElement("span", {
    className: "block text-primary-new text-xs font-semibold underline ms-1"
  }, ctaText))))))))), /*#__PURE__*/React.createElement(Story, {
    ref: storyRef,
    showStoryMode: showStory,
    closeStory: function closeStory() {
      return setShowStory(false);
    }
  }, story && story));
};
export default RadioCardNew;